module.exports = __webpack_public_path__ + "04-thumbnail.jpg?4401f886ee6d67d44bd88a13ee9110f4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/04-thumbnail.jpg
// module id = 41
// module chunks = 0